import React from "react";
import "./cta.css";

const CTA = () => (
  <div className="portfolioX__cta">
    <div className="portfolioX__cta-content">
      <p>Request Early Access to Get Started</p>
      <h3>Register Today & start exploring the endless possibilities.</h3>
    </div>
    <div className="portfolioX__cta-btn">
      <button type="button">Get Started</button>
    </div>
  </div>
);

export default CTA;
